'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.usePrevious = void 0;
const react_1 = require('react');
function usePrevious(value) {
  const ref = react_1.useRef();
  react_1.useEffect(() => {
    ref.current = value;
  });
  if (!ref.current) return '';
  return ref.current;
}
exports.usePrevious = usePrevious;
